<template>
  <div class="bg-light rounded p-3">
    <h2>Introduction</h2>
    <p class="lead">
      This is resource database of <i>A chromosome-level genome assembly provides insights into Cornus wilsoniana evolution, oil biosynthesis and floral bud development</i> manuscript.
      This database mainly includes the <b>Genome Browser</b> and <b>Blast</b> of Cornus wilsoniana which had already assembled into chromosome-level. Also, users can download other assambly 
      version from this database (e.g. scaffold). Users can also use <b>Gene Tab</b> to find genes' information. The <b>Download tab</b> also provides RNA-seq bigwig files for users downloading.
      Have fun with Sojak Database!
    </p>
  </div>
</template>

<script>
export default {

}
</script>

<style scoped>
  div {
    padding: 0.375rem 0.525rem;
  }
</style>